import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SettingsSetterDirective } from 'src/business/models/general-element-settings';
import { Sticker } from 'src/business/sticker/sticker.component';
import { UmbracoImage, UmbracoSourceset } from 'src/core-lib/umbraco/umbraco-image.model';
import { ImgDirective } from 'src/layout/media/directives/img.directive';


@Component({
    selector: 'app-image-with-link',
    templateUrl: './image-with-link.component.html',
    styleUrl: './image-with-link.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageWithLinkComponent extends SettingsSetterDirective {
    image: UmbracoImage;
    imageMobile: UmbracoImage;
    size: string;
    sourceset: UmbracoSourceset[];
    text: string;
    superText: string;
    link: string;
    arrow: boolean;
    sticker: Sticker;
    imgSize: string;
    srcset: string;

    ngOnInit(): void {
        super.ngOnInit()
        let _elm = this.elm.nativeElement;
        if (_elm.closest('app-carousel-simple') != null)
            this.imgSize = 'content-quart';
        else
            this.imgSize = 'content-full';


        let backgroundImageUrl = new URL(this?.image?.imageUrl);
        let backgroundImageMobileUrl = new URL(this?.imageMobile?.imageUrl ?? this?.image?.imageUrl);
        Object
            .entries(Object.assign({}, ImgDirective.QUERY_ENTRIES))
            .forEach(([key, value]) => {
                backgroundImageUrl.searchParams.set(key, value);
                backgroundImageMobileUrl.searchParams.set(key, value);
            });

        this.srcset = [
            ImgDirective._sourceSet(backgroundImageMobileUrl, null, SettingsSetterDirective.SRCSET_SIZES.mobile ?? []),
            ImgDirective._sourceSet(backgroundImageUrl, null, SettingsSetterDirective.SRCSET_SIZES.desktopM ?? []),
        ]
            .join(',')
    }
}
